module.exports = __webpack_public_path__ + "img/step23_table.322f59af.png";